import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from './not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: './modules/common-main/common-main.module#CommonMainModule'
  },
  {
    path: 'admin',
    loadChildren: './modules/admin/admin.module#AdminModule'
  },
  {
    path: 'moderator',
    loadChildren: './modules/moderator/moderator.module#ModeratorModule'
  },
  {
    path: 'user',
    loadChildren: './modules/user/user.module#UserModule'
  },
  {
    path: 'enroll',
    loadChildren: './modules/enroll/enroll.module#EnrollModule'
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, {useHash: true, preloadingStrategy: PreloadAllModules})],
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}





// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts